export default __webpack_public_path__ + "images/dfabe97e28d6167d7b831e6f5f003ebe-environment.jpg";